export default __webpack_public_path__ + "static/media/Marathi-letter-convnet.ad52eb5f.md";